import { all, fork, call, put, takeEvery, CallEffect, PutEffect } from "redux-saga/effects";
import { fetchError, onGetGuidSuccess } from "../actions";
import { ActionTypes } from "../../constants/ActionTypes";
import { ShowError } from "../../helper/Alert";
import FaraGostarDynamicHttp from "../../api/FaraGostarDynamicHttp";
import { AxiosResponse } from "axios";

// newLetter
const createGuid = async () => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`Letter/GetGuid`);
}

function* getGuidRequest(): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const guid = yield call(createGuid);
        yield put(onGetGuidSuccess(guid));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* getGuid() {
    yield takeEvery(ActionTypes.GET_GUID, getGuidRequest);
}

export default function* rootSaga() {
    yield all([fork(getGuid)]);
}
